export default {
  grouping: {
    groupBy: "Group by",
    assetClass: "Asset class",
    currency: "Currency",
    sector: "Sector",
    region: "Region",
    strategy: "Strategy",
    uncategorized: "Uncategorized",
  },
  pages: {
    avg: "Average",
    max: "Max",
    min: "Min",
    footer: {
      page: "Page",
    },
    strategyReport: {
      title: "Investment Proposal",
      strategyName: (ctx) =>
        `Strategy name: ${ctx.named("portfolioName")} (${ctx.named("currency")})`,
      forRecipient: (ctx) => `For: ${ctx.named("recipient")}`,
      preparedBy: (ctx) => `Prepared by: ${ctx.named("author")}`,
      period: (ctx) => `Period: ${ctx.named("periodStart")} - ${ctx.named("periodEnd")}`,
    },
    tableOfContents: {
      title: "Table of Contents",
    },
    portfolioComposition: {
      title: "Portfolio Composition",
      currencyAlloc: "Currency Allocation",
      assetClassAlloc: "Asset Class Allocation",
      sectorAlloc: "Sector Allocation",
      regionAlloc: "Region Allocation",
      composition: "Composition",
    },
    performanceAnalysis: {
      title: "Performance Analysis",
      investGrowth: "Investment Growth",
      keyPerfStats: {
        title: "Key Performance Statistics",
      },
      histYearyRets: "Historical Yearly Returns",
      histMonthRets: "Historical Monthly Returns",
    },
    riskAnalysis: {
      title: "Risk Analysis",
      drawdownAnalysis: "Drawdown Analysis",
      drawdownTable: {
        title: "Drawdown Table",
        drawdownRank: "Drawdown Rank",
        startDate: "Start Date",
        troughDate: "Trough Date",
        recoveryDate: "Recovery Date",
      },
    },
    portfolioHoldings: {
      title: "Portfolio Holdings",
      topHoldings: {
        title: "Top Holdings",
        name: "Name",
        isin: "ISIN",
        currency: "Currency",
        assetClass: "Asset class",
        sector: "Sector",
        region: "Region",
        weight: "Weight",
      },
    },
  },
  productPicker: {
    add: "Add",
    searchPlaceholder: "Search for a product...",
  },
  report: {
    backToInputs: "Go back to inputs",
    downloadReport: "Download report",
    taskFailed: (ctx) => `Task ${ctx.named("taskName")} failed: ${ctx.named("reason")}`,
  },
  reportInputs: {
    generateReport: "Generate report",
    fields: {
      general: {
        title: "General",
        portfolioName: "Portfolio name",
        currency: "Currency",
        author: "Author",
        recipient: "Recipient",
        totalCapital: (ctx) => `Total capital (${ctx.named("currency")})`,
        totalCapitalTooltip:
          "Used to show the invested amount of each position in the top holdings table, assuming this capital at the end of the period. Leave empty to hide that column.",
      },
      composition: {
        title: "Composition",
        product: "Product",
        availableFrom: "Available from",
        availableUntil: "Available until",
        period: "Period",
        fullPeriod: "Full period",
        weight: "Weight (%)",
        addProduct: "Add product",
        total: "Total",
        selectOneProduct:
          "Select at least one product in the composition to be able to select a period.",
        noOverlappingPricePeriod:
          "The selected products have no overlapping price history, so a reporting period cannot be selected.",
      },
      miscellaneous: {
        title: "Miscellaneous",
        numMonthlyReturns: "Number of years for historical monthly returns",
        numTopHoldings: "Number of holdings for top holdings",
        numTopHoldingsTooltip: "Leave empty to get all holdings.",
      },
    },
  },
  weightOptimization: {
    portfoliosWeightsAllocation: "Portfolios' weights allocation",
    addProduct: "Add product",
    addPortfolio: "Add portfolio",
    total: "Total",
    chartsAndTables: {
      buttonText: "Generate charts and tables",
      dataLoadError:
        "An error occurred while loading the data. Please try again or contact Alquant AG if the issue persists.",
      drawdowns: "Drawdowns",
      performance: "Performance",
      period: "Period",
      periodSelectionCondition:
        "Ensure that every component with a non-zero weight in any portfolio has a selected product.",
      returnToRiskSpace: "Return to risk space",
      selectedPortfolios: "Selected portfolios",
      statistics: "Statistics",
      year: "Year",
      yearlyReturns: "Yearly returns",
    },
    actionTooltip: {
      restoreDefaultPortfolio: (ctx) =>
        `Revert to the default allocation for '${ctx.named("portfolioName")}'.`,
      optimizeWeight: (ctx) =>
        `Optimize weights for '${ctx.named("portfolioName")}' based on constraints and objectives.`,
      cantOptimizeWeight:
        "Optimization requires a selected product for every row, plus at least one position.",
      usePortfolioToGenerateReport: (ctx) =>
        `Generate a report using the '${ctx.named("portfolioName")}' portfolio.`,
      cantGenerateReport:
        "Report generation requires a selected product for every row, and a total allocation of exactly 100%.",
      removePortfolio: (ctx) => `Remove '${ctx.named("portfolioName")}' from the comparison.`,
      cantRemovePortfolio: "At least one portfolio must remain in the comparison.",
    },
    optimizationDialog: {
      title: "Optimization settings",
      objective: "Objective",
      period: "Optimization period",
      bounds: "Allocation bounds",
      addBound: "Add bound",
      singlePosition: "Single position",
      type: "Type",
      target: "Target",
      min: "Min",
      max: "Max",
      buttonText: "Run optimization",
      optimization: {
        maxRetWithTargetMaxVol: {
          name: "Maximize return (target annual volatility)",
          targetTitle: "Maximum annual volatility",
        },
        maxRetWithTargetPainIndex: {
          name: "Maximize return (target pain index)",
          targetTitle: "Maximum pain index",
        },
        maxRetWithTargetMaxDrawdown: {
          name: "Maximize return (target drawdown)",
          targetTitle: "Maximum drawdown",
        },
        minVolWithTargetMinRet: {
          name: "Minimize volatility (target annual return)",
          targetTitle: "Minimum annual return",
        },
        minDrawdownWithTargetMinRet: {
          name: "Minimize maximum drawdown (target annual return)",
          targetTitle: "Minimum annual return",
        },
        maxSharpe: {
          name: "Maximize sharpe ratio",
        },
        maxSortino: {
          name: "Maximize sortino ratio",
        },
      },
    },
    failedOptimizationDialog: {
      title: "Optimization Failed",
      text: "No solution found. The constraints (target values and allocation limits) may be too restrictive.",
    },
  },
};
